// eslint-disable-next-line import/prefer-default-export
export const INFR_CHANGE_WORKSPACES = (state, { workspaces }) => ({
  ...state,
  workspaces
});
